import React from 'react';
import { GoogleFilesPanel } from './GoogleFilesPanel';
import { FileText } from 'lucide-react';
export function GoogleDocsPanel() {
  return <GoogleFilesPanel title="Google Docs" description="Documentos de texto, propuestas y specs del equipo." mimeType="application/vnd.google-apps.document" icon={<FileText size={24} data-id="element-4761" />} colorClass="text-blue-400" bgClass="bg-blue-500/10" borderClass="border-blue-500/20" glowClass="bg-blue-500/10" data-id="element-4760" />;
}